import React from 'react';
import ReactDOM from 'react-dom';
import { apiService } from '../../common/apiCallService';
import Loading from '../Loading.js';
import { baseUrl, domain } from '../../common/config.js';
import Paper from 'material-ui/Paper';
import Menu from '../Menu.js';
import { Card, CardActions, CardHeader, CardMedia, CardTitle, CardText } from 'material-ui/Card';
import ReactPlayer from 'react-player';
import MediaQuery from 'react-responsive';
import { Redirect } from 'react-router';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';
import CourseContent from './CourseContent.js';
import './course.css'
import Divider from 'material-ui/Divider';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
let PartyPokerIcon = "//" + domain + "/images/replayerIcons/PartyPokerIcon.png"
import { createVirtualPageLoad, closeVirtualPage, saveActivity } from '../../common/commonService'
import queryString from 'query-string';
import { getColor, getDarkTextColor, getHoverColor, getImage, getTextColor } from '../../common/ThemeService';
import Header from '../../container/Header/Header';

class Course extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      moduleList: [],
      indexList: [],
      contentType: 'module',
      activeModule: {},
      activeLesson: {},
      activelessonContent: [],
      showIndex: false,
      loading: false,
      courseList: props.location.state ? props.location.state.courseList : null,
      activeCourse: props.location.state ? props.location.state.activeCourse : {},
      videoInfo: { playedSeconds: 0, played: 0, loadedSeconds: 0, loaded: 0, activeLesson: '', order: 0 },
      redirectFrmReportcard: props.match.params.module ? true : false

    }
    
    if (props.match.params.module) { 
    this.getCourseContent()
    } else {
      if (!props.location.state) {
        this.getOnloadCourseContent()
      } else {
        this.getModules()
      }
    }
  }

  componentDidMount() {
    const { source, stat, grade } = queryString.parse(this.props.location.search);
    const lessons = this.props.location.pathname.split('/')[2];
    if (source == 'report-card' || source == 'liveview') {
      let activityTrack = []
      let track = {}
      if (localStorage.getItem('activityTrack'))
        activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
      track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        track.session_id = localStorage.getItem("token")
      track.userid = localStorage.getItem("username")
      track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
      if (source == 'report-card')
        track.hit_page = 'ReportCard'
      else 
        track.hit_page = 'PokerwhizChat'
      track.hit_type = 'ReportCardClinicVisit'
      track.hit_attribute1 = stat
      track.hit_attribute2 = lessons
      track.hit_attribute3 = grade
      track.hit_attribute4 = ''
      track.hit_attribute5 = ''
      track.hit_player = queryString.parse(this.props.location.search).accountName ? queryString.parse(this.props.location.search).accountName : localStorage.getItem('accountName')
      activityTrack.push(track)
      localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
    } 
    createVirtualPageLoad("/course");
  }

  getOnloadCourseContent = () => {
    this.state.loading = true
    this.forceUpdate()
    // this.setState({ loading: true })
    apiService(baseUrl + '/clinic/getCourseContent', {
      "type": 'Course'
    }, (data) => {
      let activeCourse=this.state.activeCourse
      data.courses.map((course, index) => {
        if(course.contentName===this.props.match.params.course){
          this.setState({activeCourse:course})
        }
        if (!course.order) course.order = 0
        if (data.courses.length != index + 1) course.nextLessonStyle = 'next-prev-active-button'
        else course.nextLessonStyle = 'next-prev-button'
        if (index == 0) course.prevLessonStyle = 'next-prev-button'
        else course.prevLessonStyle = 'next-prev-active-button'
      })
      this.setState({ courseList: data.courses })
      this.getModules();
      this.setState({ loading: false })
    }, (data) => {
      this.setState({ loading: false })
    })
  }

  componentWillUnmount() {
    closeVirtualPage()
  }

  getCourseContent = () => {
    // this.setState({ loading: true })
    this.state.loading = true
    this.forceUpdate()
    apiService(baseUrl + '/clinic/getCourseContent', {
      "type": 'Course'
    }, (data) => {
      this.setState({ contentType: 'lesson' })
      let activeModule, activeLesson
      data.modules.map((module, index) => {
        module.map(moduleObj => {
          moduleObj.styleClass = 'course-index'
          if (moduleObj.contentName === this.props.match.params.module) {
            activeModule = moduleObj
            this.setState({ moduleList: module })
            data.courses.map((course, index) => {

              if (moduleObj.parentId == course._id) {
                this.setState({ activeCourse: course })
              }
            })
            this.setState({ activeModule: moduleObj })
            this.getLesson(moduleObj)
          }
        })
      })

      this.setState({ loading: false })

    }, (data) => {
      this.setState({ loading: false })
    })
  }

  getModules(activeCourse = this.state.activeCourse) {
    // this.setState({ loading: true })
    this.state.loading = true
    this.forceUpdate()
    apiService(baseUrl + '/clinic/getModules', {
      "_id": activeCourse._id
    }, (modules) => {
      modules.map((module) => {
        if(this.props.match.params 
          && this.props.match.params.lesson 
          && module.contentName ==this.props.match.params.lesson ){
            this.setState({ activeModule: module })
            this.getLesson(module);
            module.styleClass = 'course-index'
        }
        else if (module.order == 1) {
          this.setState({ activeModule: module })
          module.styleClass = 'course-index'
        }
        else module.styleClass = 'course-index'
      })
      this.setState({ moduleList: modules })
      this.setState({ indexList: modules })
      this.setState({ loading: false })
    }, (data) => {
      this.setState({ loading: false })
    })
  }

  getLesson = (module) => {
    this.setState({ activeModule: module })
    this.setState({ contentType: 'lesson' })
    this.state.loading = true
    this.forceUpdate()
    apiService(baseUrl + '/clinic/getLessons', {
      "_id": module._id
    }, (data) => {
      let subLesson =  data.lessons.filter((lesson)=> queryString.parse(this.props.location.search).sublesson === lesson.contentName )
      let order = subLesson.length > 0 ? subLesson[0].order: 1
      data.lessons.map((lesson, index) => {
        if (data.lessons.length != index + 1) lesson.nextLessonStyle = 'next-prev-active-button'
        else lesson.nextLessonStyle = 'next-prev-button'
        if (index == 0) lesson.prevLessonStyle = 'next-prev-button'
        else lesson.prevLessonStyle = 'next-prev-active-button'
        if (lesson.order == order) {
          lesson.styleClass = 'course-introduction'
          this.setState({ activeLesson: lesson })
          this.getLessonContent(lesson)
        }
        else lesson.styleClass = 'course-index'
      })
      this.setState({ indexList: data.lessons })
      window.scrollTo(0, 0)    
      this.setState({ loading: false })
    }, (data) => {
      this.setState({ loading: false })
    })
  }

  getLessonContent = (lesson, showIndex = false) => {
    // this.setState({ loading: true })
    this.state.loading = true
    this.forceUpdate()
    if (!showIndex) {
      let showIndex = this.state.showIndex
      this.setState({ showIndex: !showIndex })
    }
    this.state.indexList.map((lessons) => {
      if (lessons._id == lesson._id) lessons.styleClass = 'course-introduction'
      else lessons.styleClass = 'course-index'
    })
    this.setState({ activeLesson: lesson })
    this.setState({ contentType: 'lesson' })

    // let activityTrack = []
    // let track = {}
    // if (localStorage.getItem('activityTrack'))
    //   activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
    // track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
    //   track.session_id = localStorage.getItem("token")
    // track.userid = localStorage.getItem("username")
    // track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
    // track.hit_page = 'CourseContent'
    // track.hit_type = 'CourseContentPageView'
    // track.hit_attribute1 = this.state.activeCourse.contentName
    // track.hit_attribute2 = this.state.activeModule.contentName
    // track.hit_attribute3 = lesson.contentName
    // track.hit_attribute4 = ''
    // track.hit_attribute5 = ''
    // track.hit_player = queryString.parse(this.props.location.search).accountName ? queryString.parse(this.props.location.search).accountName : localStorage.getItem('accountName')
    // activityTrack.push(track)
    // localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
    saveActivity({
      hit_timestamp: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      session_id: localStorage.getItem("token"),
      userid: localStorage.getItem("username"),
      deviceInfo: JSON.parse(localStorage.getItem("deviceInfo")),
      hit_page: 'CourseContent',
      hit_type: 'CourseContentPageView',
      hit_attribute1: this.state.activeCourse.contentName,
      hit_attribute2: this.state.activeModule.contentName,
      hit_attribute3: lesson.contentName,
      hit_attribute4: '',
      hit_attribute5: '',
      hit_player: queryString.parse(this.props.location.search).accountName ? queryString.parse(this.props.location.search).accountName : localStorage.getItem('accountName')
    })
    apiService(baseUrl + '/clinic/getLessonContent', {
      "moduleID": this.state.activeModule._id,
      "lessonID": lesson._id
    }, (data) => {
      window.scrollTo(0, 0);
      this.setState({ activelessonContent: data })
      this.setState({ loading: false })
    }, (data) => {
      this.setState({ loading: false })
    })
  }

  onStart = () => {
    let activityTrack = []
    let track = {}
    if (localStorage.getItem('activityTrack'))
      activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
    track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      track.session_id = localStorage.getItem("token")
    track.userid = localStorage.getItem("username")
    track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
    track.hit_page = 'CourseContent'
    track.hit_type = 'CourseContentClickVideo'
    track.hit_attribute1 = this.state.videoInfo.course
    track.hit_attribute2 = this.state.videoInfo.module
    track.hit_attribute3 = this.state.videoInfo.activeLesson
    track.hit_attribute4 = ''
    track.hit_attribute5 = ''
    track.hit_player = queryString.parse(this.props.location.search).accountName ? queryString.parse(this.props.location.search).accountName : localStorage.getItem('accountName')
    // track.hit_attribute4=(this.state.videoInfo.played * 100).toFixed(2)== 100 ? 'Full Play' : 'Partial Play'
    // track.hit_attribute5=(this.state.videoInfo.played * 100).toFixed(2)== 100 ? '' : this.state.played
    activityTrack.push(track)
    this.state.videoInfo = {}
    localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
  }

  getActiveLessons = (lessonOrder, showIndex = false) => {
    window.scrollTo(0, 0)
    this.state.indexList.map((lesson, index) => {
      if (lesson.order == lessonOrder) {
        lesson.styleClass = 'course-introduction'
        this.setState({ activeLesson: lesson })
        this.getLessonContent(lesson, showIndex)
      }
      else lesson.styleClass = 'course-index'
    })
  }

  goBack = () => {
    if (this.state.contentType == 'lesson') {
      this.setState({ indexList: this.state.moduleList })
      this.setState({ contentType: 'module' })
      // this.setState({ showIndex: false })
    }
    else {
      this.props.history.push({
        pathname: '/course'
      })
    }
  }

  browseIndex = () => {
    let showIndex = this.state.showIndex
    this.setState({ showIndex: !this.state.showIndex })
  }

  getActiveCourse = (courseOrder) => {
    this.state.courseList.map((course, index) => {
      if (course.order == courseOrder) {
        this.setState({ activeCourse: course })
        this.getModules(course)
      }
    })
  }

  onProgress = state => {
    state.course = this.state.activeCourse.contentName
    state.module = this.state.activeModule.contentName
    state.activeLesson = this.state.activeLesson.contentName
    state.order = this.state.activeLesson.order
    this.setState({ videoInfo: state })

  }
  goBackToReportCard = () => {
    let activityTrack = []
    let track = {}
    if (localStorage.getItem('activityTrack'))
      activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
    track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      track.session_id = localStorage.getItem("token")
    track.userid = localStorage.getItem("username")
    track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
    track.hit_page = 'CourseContent'
    track.hit_type = 'ClickBackToReportCard'
    track.hit_attribute1 = this.state.activeCourse.contentName
    track.hit_attribute2 = this.state.activeModule.contentName
    track.hit_attribute3 = this.state.activeLesson.contentName
    track.hit_attribute4 = ''
    track.hit_attribute5 = ''
    track.hit_player = queryString.parse(this.props.location.search).accountName ? queryString.parse(this.props.location.search).accountName : localStorage.getItem('accountName')
    activityTrack.push(track)
    this.state.videoInfo = {}
    localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
    this.props.history.goBack()
  }
  render() {
    const themeColor = getColor();
    const themeTextColor = getTextColor();
    const themeHoverColor = getHoverColor();
    const themeDarkTextColor = getDarkTextColor();
    this.props.setHeaderTitle('Course')
    return (
      <div style={{ background: 'white' }}>
        {localStorage.getItem('token') && <Header />}
        <style>
          {`\
            .course-introduction, .next-prev-active-button:hover {\
              background-color: ${themeColor};\
              color: ${themeTextColor};\
            }\
            .back-course-text , .backTo-course-button {\
              border-color: ${themeColor};\
              color: ${themeDarkTextColor};\
            }\
            .backTo-course-button:hover {\
              background-color: ${themeHoverColor};\
              border-color: ${themeColor};\
            }\
          `}
        </style>
        {this.state.loading ? <Loading /> : null}
        <div className='course-index-content-page' style={{ backgroundColor: 'white'}} >
          <div className="row" style={{ paddingTop: !JSON.parse(localStorage.getItem('fromClient')) && localStorage.getItem('token') ? '50px' : '0px', margin: 0, paddingBottom: '2.1%' }}>
            {this.state.indexList.length > 0
              ?
              <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 index-width" style={{ padding: '0' }}>
                < CourseIndex
                  redirectFrmReportcard={this.state.redirectFrmReportcard}
                  activeModule={this.state.activeModule}
                  course={this.state.activeCourse}
                  contentType={this.state.contentType}
                  getLesson={this.getLesson}
                  indexList={this.state.indexList}
                  getLessonContent={this.getLessonContent}
                  goBack={this.goBack}
                  browseIndex={this.browseIndex}
                  showIndex={this.state.showIndex}
                  activeLesson={this.state.activeLesson}
                  goBackToReportCard={this.goBackToReportCard}
                />
              </div>
              : null}
            {this.state.contentType === 'module'
              ?
              <span>
                <MediaQuery maxWidth={991}>
                  <CourseIntro
                    showIndex={this.state.showIndex}
                    activeCourse={this.state.activeCourse}
                    getActiveCourse={this.getActiveCourse}
                    redirectFrmReportcard={this.state.redirectFrmReportcard}
                  />
                </MediaQuery>
                <MediaQuery minWidth={992}>
                  <CourseIntro
                    showIndex={false}
                    activeCourse={this.state.activeCourse}
                    getActiveCourse={this.getActiveCourse}
                    redirectFrmReportcard={this.state.redirectFrmReportcard}
                  />
                </MediaQuery>
              </span>
              : this.state.activelessonContent.length > 0
                ?
                <MediaQuery minWidth={992}>
                  {(matches) => {
                    if (matches) {
                      return (
                        <CourseContent
                          deskTop={true}
                          redirectFrmReportcard={this.state.redirectFrmReportcard}
                          getActiveLessons={this.getActiveLessons}
                          activelessonContent={this.state.activelessonContent}
                          activeModule={this.state.activeModule}
                          activeCourse={this.state.activeCourse}
                          activeLesson={this.state.activeLesson}
                          showIndex={this.state.showIndex}
                          onProgress={this.onProgress}
                          onStart={this.onStart}
                          goBackToReportCard={this.goBackToReportCard}
                          accountName={queryString.parse(this.props.location.search).accountName ? queryString.parse(this.props.location.search).accountName : localStorage.getItem('accountName')}
                          prevPath={this.props.location.state ? this.props.location.state.prevPath : '/'}
                          />
                      )
                    } else {
                      return (
                        !this.state.showIndex
                          ?
                          <CourseContent
                            deskTop={false}
                            redirectFrmReportcard={this.state.redirectFrmReportcard}
                            getActiveLessons={this.getActiveLessons}
                            activelessonContent={this.state.activelessonContent}
                            activeModule={this.state.activeModule}
                            activeCourse={this.state.activeCourse}
                            activeLesson={this.state.activeLesson}
                            showIndex={this.state.showIndex}
                            onProgress={this.onProgress}
                            onStart={this.onStart}
                            goBackToReportCard={this.goBackToReportCard}
                            accountName={queryString.parse(this.props.location.search).accountName ? queryString.parse(this.props.location.search).accountName : localStorage.getItem('accountName')}
                            prevPath={this.props.location.state ? this.props.location.state.prevPath : '/'}
                            />
                          : null
                      )
                    }
                  }}
                </MediaQuery>
                : null
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setHeaderTitle : ( newTitle ) => dispatch(actions.setHeaderTitle( newTitle ))
  }
};

export default connect(null, mapDispatchToProps)(Course);

const CourseIndex = props => {
  return (
    <span>
      <div className='course-title'>
        {props.contentType == 'module'
          ? <p className='mob-course-title'>{props.course.contentName}</p> : <p className='mob-course-title'>{props.activeModule.order}. {props.activeModule.contentName}</p>}
      </div>
      {/* <MediaQuery maxWidth={991}>
        {props.redirectFrmReportcard
          ?<span style={{ float: 'right', paddingRight: '3.6%' }}>
            <button style ={{outline:0,border:'none'}} className='backToReportCard' onClick={() => props.goBackToReportCard()}>Back to report card</button>
          </span>
          : null}
      </MediaQuery> */}
      <MediaQuery minWidth={992}>
        <BackToModule course={props.course} goBack={props.goBack} contentType={props.contentType} />
        {props.contentType === 'module'
        ?<div className='course-introduction'>Introduction</div>
        :null}
         {props.indexList.map((module, index) => {
          return (
            <span key={index} data-e2e={module.contentName}>  {/*data-e2e="courseList"*/} 
            <div style={{ cursor: 'pointer' }} className={module.styleClass == 'course-index' ? 'parent-course-index' : ''} onClick={() => {
                window.scrollTo(0, 0);  
              props.contentType === 'module' ? props.getLesson(module) : props.getLessonContent(module)}}data-e2e={module.contentName} >
              <p className={module.styleClass + ' mob-color'}>{props.contentType === 'module' ? index + 1 + '.' : null} {module.contentName} </p>
            </div>
            </span>
          )
        })}
      </MediaQuery>
      <MediaQuery maxWidth={991}>
        <div className='row course-introduction'style={{ height: 'auto'}}>
            <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10 " style={{ padding: '0' }}>
              {props.contentType === 'module' ? 'Introduction' : props.activeLesson.contentName}
            </div>
          <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 " style={{ padding: '0' }}>
              <span className='browse-button' onClick={props.browseIndex}>
                {!props.showIndex
                  ? <span style={{ verticalAlign: 'middle', fontSize: '12px',cursor:'pointer'}}>
                    <span className='mob-display'>BROWSE</span>
                    <i className="fa fa-angle-down" style={{ fontSize: '27px', verticalAlign: 'middle', fontWeight: 'bold', paddingLeft: '5.38px'}}></i>
                  </span>
                  : <span style={{ verticalAlign: 'middle', fontSize: '12px',cursor:'pointer'}}>
                    <span className='mob-display' >CLOSE</span>
                    <i className="fa fa-angle-up" style={{ fontSize: '27px', verticalAlign: 'middle', fontWeight: 'bold', paddingLeft: '5.38px'}}></i>
                  </span>}
              </span>
          </div>
        </div>
        </MediaQuery>

      <MediaQuery maxWidth={991}>
        {props.showIndex
          ?
          <div className='mob-tab-course-display'>
            <BackToModule style={{ marginTop: '0' }} course={props.course} goBack={props.goBack} contentType={props.contentType} />
            <Divider style={{ marginTop: '8.8px', height: "1px", backgroundColor: '#eee' }} />
            {props.indexList.map((module, index) => {
              return (
                <span >
                  <div className='parent-course-index' style={{ paddingLeft: '0', cursor: 'pointer' }}
                    onClick={() => props.contentType === 'module' ? props.getLesson(module) : props.getLessonContent(module)} >
                    <p className='course-index mob-color'><span>{props.contentType === 'module' ? index + 1 + '.' : null}</span> {module.contentName}</p>
                  </div>
                  <Divider style={{ marginTop: '0', height: "1px", backgroundColor: '#eee' }} />
                </span>
              )
            })}
          </div>
          : null}
      </MediaQuery>
    </span >
  )
}

const CourseIntro = props => {
  return (
    !props.showIndex
      ? <span className='course'>
        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 " style={{ padding: '0' }}>
          <span className='course-content-title defcontent' style={{ marginRight: '-15px' }}>Introduction</span>
          <div  data-e2e="introductionData" className='course-content def-course-content-width' dangerouslySetInnerHTML={{__html:props.activeCourse ? props.activeCourse.courseIntro : ''}}>
          </div>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3" >
          <img src={"//" + domain + getImage("/images/common/course/","/clinicLaptop.png")} className='def-content-img' />
        </div>
        {!props.redirectFrmReportcard
          ? <MediaQuery maxWidth={991}>
            <button style ={{outline:0,border:'none',height: '30px'}} className={props.activeCourse.prevLessonStyle} style={{ float: 'left', marginBottom: '50%',height: '30px',marginTop:'5%'}} onClick={() => props.getActiveCourse(parseInt(props.activeCourse.order) - 1)}>
              <i className="fa fa-angle-left" style={{ fontWeight: 'bold', fontSize: '14px' }}></i>&nbsp;&nbsp;PREVIOUS CLASS
          </button>
            <button style ={{outline:0,border:'none',height: '30px'}} className={props.activeCourse.nextLessonStyle} style={{ float: 'right', marginBottom: '50%',height: '30px',marginTop:'5%'}} onClick={() => props.getActiveCourse(parseInt(props.activeCourse.order) + 1)}>NEXT CLASS&nbsp;&nbsp;
            <i className="fa fa-angle-right" style={{ fontWeight: 'bold', fontSize: '14px' }}></i>
            </button>
          </MediaQuery >
          : null}
      </span>
      : <div></div>


  )
}


const BackToModule = props => {
  const themeColor = getColor();
  return (
    <div>
      <button className='backTo-course-button' onClick={() => props.goBack()} data-e2e="the clinic" >
        <p className='back-course-text'>   
          <i className="fa fa-angle-left backTo-course-button-icon" style={{  fontWeight: 'bold', width: '11px', color: themeColor,
          fontSize: '17px',verticalAlign:'middle',lineHeight: '12px',textAlign: 'center'}}></i>&nbsp;&nbsp;
          {props.contentType == 'module' ? 'SEE ALL COURSES' : props.course.contentName.toUpperCase()}
        </p>
      </button>
    </div>
  )
}



/** WEBPACK FOOTER **
 ** ./src/components/NewCourse/Course.js
 **/